import React, {Component} from "react";
import moment from 'moment';
import { isSimilarObject } from "../../../helper";

export default class BiddingPane extends Component {

    shouldComponentUpdate(nextProps) {
        if(isSimilarObject(this.props, nextProps)) {
            return false;
        }
        return true;
    }

    render() {
        const {
            auction,
            biddingPaneHandleFields,
            biddingShow,
            sectionToggle,
            errorMessages,
            getBidsPreview,
            auctionInfo
        } = this.props;

        
        let auctionDateTime;

        if(auctionInfo) {
            auctionDateTime = auctionInfo.newDateTime || auctionInfo.dateTime;
        }
    
        return (
            <div style={{marginBottom:'15px'}}>
                <div className="bidding general-settings-new-style" style={{paddingBottom:0}}>
                    <div
                        className="bidding-title"
                        style={{borderBottom:0,marginBottom:'30px'}}
                        onClick={() => sectionToggle('biddingShow')}
                        >
                        <div style={{display:'flex',alignItems:'center',marginBottom:'6px',marginTop:'10px'}}>
                            <h3 className="create-order__title-toogle" style={{margin:0}}>
                                <span>Подбор и назначение исполнителя</span>
                                <i className={`title-toggle__arrow ${biddingShow ? 'active' : ''}`}></i>
                            </h3>
                        </div>
                        <div className="makeorder-section-info">{getBidsPreview()}</div>
                    </div>
    
                    <div
                        style={{width:'calc(100% + 60px)',marginLeft:'-30px',padding:'30px',paddingBottom:'30px',borderRadius:'0 0 20px 20px',background:'#fafafa'}}
                        className={biddingShow ? "bidding-block active" : "bidding-block"}>
                        <div className="checkboxes without-bidding width100">
                            <label className="c-form__label" htmlFor="without-bidding">
                                <label className="custom-radio">
                                    <input
                                        onChange={() => biddingPaneHandleFields(!auction.is, 'is')}
                                        type="checkbox"
                                        name="consult"
                                        id="without-bidding"
                                        value={auction.is}
                                        checked={!auction.is}
                                        style={{fontWeight:'bold',color:'#383838'}}
                                    />
                                    <div></div>
                                </label>
                                <span className="text">Без торгов</span>
                            </label>
                        </div>
    
                        {
                            auction.is ?
                            <div>
                                <div className="signature-wrap">
                                    <span className="signature">
                                        Торги начинаются за
                                    </span>
                                    <select
                                        value={auction.auction_time}
                                        onChange={(e) => biddingPaneHandleFields(e.target.value, 'auction_time')}
                                        className="form-select"
                                        style={{fontWeight:'bold',color:'#383838'}}
                                        name="sort">
                                        <option value="120">2 часа</option>
                                        <option value="240">4 часа</option>
                                        <option value="360">6 часов</option>
                                        <option value="480">8 часов</option>
                                        <option value="600">10 часов</option>
                                        <option value="720">12 часов</option>
                                        <option value="900">15 часов</option>
                                        <option value="1200">20 часов</option>
                                        <option value="1440">24 часа</option>
                                    </select>
                                </div>
    
                                {
                                    auctionDateTime ?
                                    <div style={{fontSize:'12px', marginTop:'15px', color:'#666', borderBottom:'3px solid #e2e2e2',paddingBottom:'20px'}}>
                                        {`Торги по заказу начнутся ${moment(auctionDateTime).format("DD.MM.YYYY")} числа в ${moment(auctionDateTime).format("HH")} часов ${moment(auctionDateTime).format("mm")} минут`}
                                    </div>
                                    : null
                                }
    
                                {
                                    errorMessages.auction_time ?
                                    <div className="input-error-text etmt10">{errorMessages.auction_time}</div>
                                    : null
                                }
    
                                <div className="signature-wrap" style={{width:'100%',borderBottom:'3px solid #e2e2e2',paddingBottom:'20px'}}>
                                    <span className="signature">
                                        Шаг торгов:
                                    </span>
                                    <select
                                        value={auction.step}
                                        onChange={(e) => biddingPaneHandleFields(e.target.value, 'step')}
                                        // required={publish ? true : false}
                                        className="form-select"
                                        style={{fontWeight:'bold',color:'#383838'}}
                                        name="sort">
                                        <option value="15">15 минут</option>
                                        <option value="30">30 минут</option>
                                        <option value="45">45 минут</option>
                                        <option value="60">1 час</option>
                                        <option value="90">1 час 30 минут</option>
                                        <option value="120">2 часа</option>
                                    </select>
                                </div>
                            </div>
                            : ''
                        }
    
                        <div className="signature-wrap">
                            <span className="signature">
                                Назначение исполнителя за:
                            </span>
    
                            <div className="input-wrap" style={{justifyContent: 'flex-start'}}>
                                <select
                                    value={auction.set_contractor}
                                    onChange={(e) => biddingPaneHandleFields(e.target.value, 'set_contractor')}
                                    style={{fontWeight:'bold',color:'#383838'}}
                                    className="form-select">
                                    <option value="5">5 минут</option>
                                    <option value="15">15 минут</option>
                                    <option value="30">30 минут</option>
                                    <option value="45">45 минут</option>
                                    <option value="60">1 час</option>
                                    <option value="90">1 час 30 минут</option>
                                    <option value="120">2 часа</option>
                                    <option value="180">3 часа</option>
                                    <option value="240">4 часа</option>
                                    <option value="360">6 часов</option>
                                    <option value="480">8 часов</option>
                                    <option value="720">12 часов</option>
                                    <option value="960">16 часов</option>
                                    <option value="1440">24 часов</option>
                                </select>
                            </div>
                            
                        </div>
    
                        {
                            errorMessages.set_contractor ?
                            <div className="input-error-text etmt10">{errorMessages.set_contractor}</div>
                            : null
                        }
                    </div>
                </div>
            
                {
                    auctionInfo && auctionInfo.text
                    ? <div style={{padding:'20px',width:'100%',background:'rgb(255, 219, 172)', color:'#333',fontSize:'15px'}}>{auctionInfo.text}</div>
                    : null
                }
    
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/MakeOrder/NewAndEdit/BiddingPane.js